import { Address, getAddress } from "viem";
import { arbitrumSepolia, sepolia } from "viem/chains";

import { ERC20Metadata } from "./index";

export const USDAI_TOKEN_SEP: ERC20Metadata = {
  symbol: "USDai",
  chainId: sepolia.id,
  name: "USDAI",
  address: "0xeb29fbaa2d509e43313c196a82f4ad75fa251285",
  decimals: 18,
  logo: "/svg/erc20/usdai.svg",
  OftAdapter: "0x25e80ccafd7eec96b844cf4c141733e549438b51",
  peerToken: {} as ERC20Metadata,
  mainToken: {} as ERC20Metadata,
};

export const USDAI_TOKEN_ARBSEP: ERC20Metadata = {
  symbol: "USDai",
  chainId: arbitrumSepolia.id,
  name: "USDAI",
  address: "0x5224935c456c81AeC1853d511Da13a2b9D91bBcb",
  decimals: 18,
  logo: "/svg/erc20/usdai.svg",
  OftAdapter: "0x0be2263e266eaDB7648c7693fa90075e23EEc497",
  peerToken: {} as ERC20Metadata,
  mainToken: {} as ERC20Metadata,
};

USDAI_TOKEN_SEP.peerToken = USDAI_TOKEN_ARBSEP;
USDAI_TOKEN_ARBSEP.peerToken = USDAI_TOKEN_SEP;
USDAI_TOKEN_SEP.mainToken = USDAI_TOKEN_ARBSEP.mainToken = USDAI_TOKEN_SEP;

export const PYUSD_TOKEN_SEP: ERC20Metadata = {
  symbol: "PYUSD",
  chainId: sepolia.id,
  name: "PYUSD",
  address: "0x2f6f07cdcf3588944bf4c42ac74ff24bf56e7590",
  decimals: 6,
  logo: "/svg/erc20/pyusd.svg",
  OftAdapter: "0x4985b8fcea3659fd801a5b857da1d00e985863f0",
  peerToken: {} as ERC20Metadata,
  mainToken: {} as ERC20Metadata,
};

export const PYUSD_TOKEN_ARBSEP: ERC20Metadata = {
  symbol: "PYUSD",
  chainId: arbitrumSepolia.id,
  name: "PYUSD",
  address: "0x3253a335e7bffb4790aa4c25c4250d206e9b9773",
  decimals: 6,
  logo: "/svg/erc20/pyusd.svg",
  OftAdapter: "0x543bda7c6ca4384fe90b1f5929bb851f52888983",
  peerToken: {} as ERC20Metadata,
  mainToken: {} as ERC20Metadata,
};

PYUSD_TOKEN_SEP.peerToken = PYUSD_TOKEN_ARBSEP;
PYUSD_TOKEN_ARBSEP.peerToken = PYUSD_TOKEN_SEP;
PYUSD_TOKEN_SEP.mainToken = PYUSD_TOKEN_ARBSEP.mainToken = PYUSD_TOKEN_SEP;

/* --- Derived lookups --- */

export const TESTNET_ALL_TOKENS: ERC20Metadata[] = [
  USDAI_TOKEN_SEP,
  USDAI_TOKEN_ARBSEP,
  PYUSD_TOKEN_SEP,
  PYUSD_TOKEN_ARBSEP,
];

export const TESTNET_TOKENS_ADAPTERS: Record<Address, Address> = Object.fromEntries(
  TESTNET_ALL_TOKENS.flatMap((t) => [
    [getAddress(t.address), t.OftAdapter],
    [t.address.toLowerCase(), t.OftAdapter],
  ]),
);

export const TESTNET_TOKENS_PEER: Record<Address, Address> = Object.fromEntries(
  TESTNET_ALL_TOKENS.flatMap((t) => [
    [getAddress(t.address), t.peerToken.address],
    [t.address.toLowerCase(), t.peerToken.address],
  ]),
);
